import * as React from 'react'
import { ActivityTypeId } from '@/lib/api/company/chartScan/types'
import {
  ChartShortcutAction,
  resolveChartEditorShortcut,
} from './chartActivityModes'

type Handlers = {
  addingMode: ActivityTypeId | null
  onSetMode: (mode: ActivityTypeId | null) => void
  onDeleteSelected: () => void
  onDeleteAllOfType: (type: ActivityTypeId) => void
  onUndo: () => void
  onRedo: () => void
}

export function useChartEditorShortcuts(enabled: boolean, h: Handlers) {
  const hRef = React.useRef(h)
  hRef.current = h
  React.useEffect(() => {
    if (!enabled) return
    const onKey = (e: KeyboardEvent) => {
      const action = resolveChartEditorShortcut(
        e,
        e.target as { tagName?: string; isContentEditable?: boolean } | null,
        hRef.current.addingMode,
      )
      if (!action) return
      e.preventDefault()
      e.stopPropagation()
      dispatchChartShortcut(action, hRef.current)
    }
    window.addEventListener('keydown', onKey, true)
    return () => window.removeEventListener('keydown', onKey, true)
  }, [enabled])
}

function dispatchChartShortcut(action: ChartShortcutAction, h: Handlers) {
  switch (action.kind) {
    case 'setMode':
      h.onSetMode(action.mode)
      return
    case 'deleteSelected':
      h.onDeleteSelected()
      return
    case 'deleteAllOfType':
      h.onDeleteAllOfType(action.type)
      return
    case 'undo':
      h.onUndo()
      return
    case 'redo':
      h.onRedo()
  }
}
